<template>
    <div>
        <h1>Adoption Contacts</h1>
        <b-btn variant="primary" class="mb-3" @click="downloadContacts()">Download Adoption Contacts</b-btn>

        <h1 class="mt-3">Adoption Status Pages</h1>
        <div v-for="(customer, i) in customers" class="row">
            <div class="col-6">
                Name:
                <router-link :to="`/adoption/view/${customer.customer_id}?debug=1`" class="ml-3" target="_blank">{{customer.school}}</router-link>
            </div>
            <div class="col-3">
                Customer ID:
                <router-link :to="`/adoption/view/${customer.customer_id}?debug=1`" class="ml-3" target="_blank">{{customer.customer_id}}</router-link>
            </div>
            <div class="col-2">
                Series:
                <span class="ml-1" style="color: #3498db">
                    {{customer.count}}
                </span>
            </div>
            {{customer.contacts}}
        </div>
    </div>
</template>

<script>
export default {
    name: "Adoptions",
    data: () => ({
        customers: [],
        contacts: [],
    }),
    created() {
        this.getCustomers();
    },
    methods: {
        findContactByCompanyId(companyId) {
            return this.contacts.filter((a) => {
                return a.district_company_id == companyId || a.school_company_id == companyId;
            });
        },
        getCustomers() {
            this.axios.get('/adoption/').then((response) => {
                this.customers = response.data;
                for (let i = 0 ; i < this.customers.length; ++i) {
                    this.customers[i].contacts = this.findContactByCompanyId(this.customers[i].misc.data.companyID);
                }
            })
        },
        downloadContacts() {
            this.axios.get("/adoption/contact/csv").then((data) => {
                this.download(data.data);
                // let csvContent = "data:text/csv;charset:utf-8" + data.data;
                // let encodedUri = encodeURI(csvContent);
                // window.open(encodedUri);
            })
        },
        listContacts() {
            this.axios.get('/adoption/contact/list').then((data) => {
                console.log(data);
            })
        },
        download(data) {
            console.log(data);
            let file = new Blob([data], { type: 'text/csv' });
            let url = window.URL.createObjectURL(file)
            let a = document.createElement('a')
            a.setAttribute('href', url)
            a.setAttribute('download', 'adoption_contacts.csv');
            a.click()
        }
    }
}
</script>

<style scoped>

</style>